import api from './api';

/**
 * Upload large DICOM file directly to backend streaming endpoint
 * Sends raw file bytes (no FormData) and tracks progress via callback
 */
export const uploadLargeDicom = async (file, onProgress) => {
  const fileSizeMB = (file.size / 1024 / 1024).toFixed(2);
  console.log(`Starting direct streaming upload: ${file.name} (${fileSizeMB} MB)`);

  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    xhr.upload.addEventListener('progress', (e) => {
      if (e.lengthComputable) {
        const percentComplete = Math.round((e.loaded / e.total) * 100);
        if (onProgress) onProgress(percentComplete);
        console.log(`Upload progress: ${percentComplete}% (${(e.loaded / 1024 / 1024).toFixed(2)} / ${fileSizeMB} MB)`);
      }
    });

    xhr.addEventListener('load', () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        try {
          const response = JSON.parse(xhr.responseText);
          console.log('Upload completed successfully:', response);
          resolve(response);
        } catch (e) {
          resolve({ success: true, message: 'Upload completed' });
        }
      } else {
        let errorMsg = `Upload failed: ${xhr.status} ${xhr.statusText}`;
        try {
          const errorData = JSON.parse(xhr.responseText);
          errorMsg = errorData.error || errorData.message || errorMsg;
        } catch (e) {}
        reject(new Error(errorMsg));
      }
    });

    xhr.addEventListener('error', () => {
      reject(new Error('Network error during upload. Please check your connection.'));
    });

    xhr.addEventListener('timeout', () => {
      reject(new Error('Upload timeout (10 minutes exceeded). Try again or contact support.'));
    });

    const token = localStorage.getItem('token');
    if (!token) {
      reject(new Error('Authentication required. Please log in again.'));
      return;
    }

    const baseURL = api.defaults.baseURL || '';
    xhr.open('POST', `${baseURL}/upload/direct-stream`, true);
    xhr.timeout = parseInt(process.env.REACT_APP_DIRECT_UPLOAD_TIMEOUT_MS || '600000', 10);

    xhr.setRequestHeader('Authorization', `Bearer ${token}`);
    xhr.setRequestHeader('Content-Type', 'application/dicom');

    // Send raw file (no FormData)
    xhr.send(file);
  });
};

export const shouldUseDirectUpload = (file) => {
  if (!file) return false;
  const fileName = file.name.toLowerCase();
  const isDicom = fileName.endsWith('.dcm') || fileName.endsWith('.dicom');
  const isLarge = file.size > 500 * 1024 * 1024; // 500MB
  return isDicom && isLarge;
};

export const formatFileSize = (bytes) => {
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(2) + ' KB';
  if (bytes < 1024 * 1024 * 1024) return (bytes / 1024 / 1024).toFixed(2) + ' MB';
  return (bytes / 1024 / 1024 / 1024).toFixed(2) + ' GB';
};
